export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-4.800e9572.png";